import React from 'react';
import { BrandFacebook, BrandTiktok, BrandInstagram, Mail } from 'tabler-icons-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-cancun-deep text-white"
      role="contentinfo"
      aria-label="Pied de page"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-cancun-golden">L'autrice</h3>
            <p className="text-gray-300">
              <Link 
                to="/author" 
                className="text-gray-300 hover:text-cancun-turquoise transition-colors duration-200"
                aria-label="En savoir plus sur l'autrice"
              >
                Son histoire
              </Link>
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4 text-cancun-golden">Liens Rapides</h3>
            <ul className="space-y-2" role="list">
              <li>
                <Link 
                  to="/mentions-legales" 
                  className="text-gray-300 hover:text-cancun-turquoise"
                  aria-label="Consulter les mentions légales"
                >
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link 
                  to="/confidentialite" 
                  className="text-gray-300 hover:text-cancun-turquoise"
                  aria-label="Consulter la politique de confidentialité"
                >
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4 text-cancun-golden">Contact</h3>
            <div className="space-y-4">
              <a
                href="mailto:jessica.ferramora@outlook.fr"
                className="flex items-center text-gray-300 hover:text-cancun-turquoise transition-colors duration-200"
                aria-label="Envoyer un email"
              >
                <Mail size={24} className="mr-2" />
                <span>jessica.ferramora@outlook.fr</span>
              </a>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/people/Jessica-Ferramora/61570538096670/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-cancun-turquoise transition-colors duration-200"
                  aria-label="Suivre sur Facebook"
                >
                  <BrandFacebook size={24} />
                </a>
                <a
                  href="https://www.instagram.com/jessica_ferramora/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-cancun-turquoise transition-colors duration-200"
                  aria-label="Suivre sur Instagram"
                >
                  <BrandInstagram size={24} />
                </a>
                <a
                  href="https://www.tiktok.com/@jessica.ferramora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-cancun-turquoise transition-colors duration-200"
                  aria-label="Suivre sur TikTok"
                >
                  <BrandTiktok size={24} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-300">
            © {currentYear} Jessica Ferramora. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;